import * as _ from 'lodash';

function ActivityLogReportsStore($api, $acl) {
  'ngInject';

  return {
    state: {
      loading: false,
      items: [],
      table: {
        sortedCol: 0,
        searchText: ''
      }
    },
    getters: {
      find: (state) => (id) => state.items.find((item) => item.id == id)
    },
    actions: {
      async list({ state, commit, rootState, rootGetters }, { instId } = {}) {
        let loader;

        if ($acl('GM:ListLogRequests', rootState.permissions.profile)) {
          loader = $api.GM.listLogRequests;
        } else if ($acl('IM:ListLogRequests', rootState.permissions.profile)) {
          loader = $api.IM.listLogRequests;
        } else {
          console.warn(
            `User does not have permission to execute the action: LogRequests:list`
          );
          return state.items;
        }

        commit('setProps', { loading: true });

        let data = [];

        try {
          let res = await loader({
            instId: instId ? instId : rootGetters.activeInstId
          });
          data = res.data;
        } catch (err) {
          commit('setProps', { loading: false });
          throw err;
        }

        commit('set', data);

        commit('setProps', { loading: false });

        return state.items;
      },
      async create({ dispatch, rootState, rootGetters }, payload) {
        const params = {
          institutionId: payload.institutionId,
          accountId: payload.accountId,
          startDate: payload.startDate,
          endDate: payload.endDate,
          institutionAccess: payload.institutionAccess
        };

        let loader;

        if ($acl('GM:CreateLogRequest', rootState.permissions.profile)) {
          loader = () => $api.GM.createLogRequest(params);
        } else if ($acl('IM:CreateLogRequest', rootState.permissions.profile)) {
          loader = () =>
            $api.IM.createLogRequest({ instId: payload.institutionId }, params);
        } else {
          return console.warn(
            `User does not have permission to execute the action: LogRequest:list`
          );
        }

        let res = await loader();

        await dispatch('list', { instId: rootGetters.activeInstId });

        return res;
      }
    },
    mutations: {
      set(state, payload) {
        state.items = [...payload];
      },
      add(state, payload) {
        state.items = _.uniqBy([...payload, ...state.items], 'id');
      },
      setProps(state, props = {}) {
        for (let i in props) {
          if (i in state) {
            state[i] = props[i];
          }
        }
      },
      CLEAR(state) {
        Object.assign(state, {
          loading: false,
          items: [],
          table: {
            sortedCol: 0,
            searchText: ''
          }
        });
      }
    }
  };
}

export default ActivityLogReportsStore;
